import statistics from './modules/statistics';

export default {
  statistics,
};